<template>
  <div>
    <el-form
      ref="fabricSeriesForm"
      :model="formData"
      :rules="rules"
      size="mini"
      :disabled="formDisabled"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_fabricSeriesName') || '面料系列名称'"
            prop="fabricSeriesName"
          >
            <el-input
              v-model="formData.fabricSeriesName"
              :placeholder="$l('tips_input_placeholder_fabricSeriesName') || '请输入面料系列名称'"
              maxlength="200"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item 
            :label="$l('form_label_fabricSeriesNameEn') || '面料系列名称英文'"
            prop="fabricSeriesNameEn"
          >
            <el-input
              v-model="formData.fabricSeriesNameEn"
              :placeholder="$l('tips_input_placeholder_fabricSeriesNameEn') || '请输入面料系列名称英文'"
              maxlength="200"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricAgent') || '业务人员'"
            prop="fabricAgentCode"
          >
            <dict-select
              v-model="formData.fabricAgentCode"
              :selectedLabel.sync="formData.fabricAgentName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('tips_select_fabricAgentCode') || '请选择业务人员'
              "
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricDescription') || '面料属性'"
            prop="fabricDescriptionArray"
          >
            <dict-select
              v-model="formData.fabricDescriptionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Fabric Description' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_fabricContent') || '面料成分'"
            prop="fabricContent"
          >
            <FabricContentInput
              :fabricContent.sync="formData.fabricContent"
              :fabricContentEn.sync="formData.fabricContentEn"
              :disabled="formDisabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_technology') || '工艺'">
            <dict-select
              v-model="formData.techniqueArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Technique' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_function') || '功能'">
            <dict-select
              v-model="formData.functionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Function' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_materialAttribute') || '原料属性'"
          >
            <el-input
              v-model="formData.materialAttribute"
              :placeholder="
                $l('tips_input_placeholder_materialAttribute') ||
                  '请输入原料属性'
              "
              style="width: 100%"
              maxLength="500"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricWeight') || '面料克重'"
            prop="fabricWeight"
          >
            <el-input-number
              v-model="formData.fabricWeight"
              :placeholder="
                $l('tips_input_placeholder_fabricWeight') || '请输入面料克重'
              "
              :min="0"
              :max="99999999"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricWeightUnit') || '克重单位'"
            prop="fabricWeightUnit"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'fabricWeightUnit' }"
              :placeholder="
                $l('tips_select_fabricWeightUnit') || '请选择克重单位'
              "
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_density') || '密度'">
            <el-input
              v-model="formData.density"
              :placeholder="
                $l('tips_input_placeholder_density') || '请输入密度'
              "
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_yarnWeaving') || '纱支'">
            <el-input
              v-model="formData.yarnCount"
              :placeholder="
                $l('tips_input_placeholder_yarnCount') || '请输入纱支'
              "
              maxlength="50"
              clearable
            />
          </el-form-item>

          <!-- <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fabricMemo') || '备注（风险提示）'"
              >
                <el-input
                  v-model="formData.fabricMemo"
                  :placeholder="
                    $l('tips_input_placeholder_fabricMemo') ||
                      '请输入备注（风险提示）...'
                  "
                  maxlength="500"
                  type="textarea"
                  show-word-limit
                  clearable
                  :autosize="{ minRows: 2, maxRows: 5 }"
                />
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-col>
      </el-row>
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!formDisabled"
          type="primary"
          size="mini"
          @click="save()"
          style="width: 80px"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import FabricContentInput from '@/views/ecom/components/fabric-content-input'

export default {
  mixins: [EditLoading],
  components: { FabricContentInput },
  props: {
    formDisabled: { type: Boolean, default: false },
    imageDisabled: { type: Boolean, default: false },
    fabricDisabled: { type: Boolean, default: false },
    fabricSeriesCode: { type: String, default: '' },
    // form: { type: Object },
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.fabricSeriesCode) return
        if (!userInfo || userInfo == {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData = {
          ...this.formData,
          fabricAgentCode: userCode || '',
          fabricAgentName: [userNameEn, userName].filter(Boolean).join('-') || '',
        }
      },
      immediate: true,
    },
  },
  computed: {
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
    ...mapState('admin/user', ['info']),
  },
  data() {
    return {
      formData: {
        fabricSeriesName: '',
        fabricSeriesNameEn: '',
        fabricDescriptionArray: [],
        techniqueArray: [],
        functionArray: [],
      },
      visible: false,
      rules: {
        fabricAgentCode: [
          {
            required: true,
            message: this.$l('tips_select_fabricAgent') || '请选择业务人员',
            trigger: 'change',
          },
        ],
        fabricDescriptionArray: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data_multiple') || '请选择面料属性!(可多选)',
            trigger: 'change',
          },
        ],
        fabricSeriesName: [
          {
            required: true,
            message: this.$l('tips_input_placeholder_fabricSeriesName') || '请输入面料系列名称',
            trigger: 'blur',
          },
        ],
        fabricSeriesNameEn: [
          {
            required: true,
            message: this.$l('tips_input_placeholder_fabricSeriesNameEn') || '请输入面料系列名称英文',
            trigger: 'blur',
          },
        ],
        fabricContent: [
          {
            required: true,
            message: this.$l('tips_select_fabricContent') || '请选择面料内容',
            trigger: 'change',
          },
          {
            required: true,
            message: this.$l('tips_select_fabricContent') || '请选择面料内容',
            trigger: 'blur',
          },
        ],
        patternArray: [
          {
            required: true,
            message:
              this.$l('tips_select_data_multiple') || '请选择数据!(可多选)',
            trigger: 'change',
          },
        ],
        fabricWeight: [
          {
            required: true,
            message:
              this.$l('tips_input_placeholder_fabricWeight') ||
              '请输入面料克重',
            trigger: 'blur',
          },
        ],
        fabricWeightUnit: [
          {
            required: true,
            message:
              this.$l('tips_select_fabricWeightUnit') || '请选择克重单位',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.fabricSeriesCode) return
      const data = await this.$api
        .masterFabricSeriesDetail({ fabricSeriesCode: this.fabricSeriesCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.formData = {
        ...this.formData,
        ...data,
      }
      this.$emit('loaded', this.formData)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.fabricSeriesForm])
      if (!result) return
      this.loadingOpen()
      this.$api
        .masterFabricSeriesEcomSave(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status, body } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (this.fabricSeriesCode) {
            this.getData()
            return
          }

          const { fabricSeriesCode = '', fabricSeriesNo = '' } = body || {}
          if (fabricSeriesCode) {
            this.$router.replace({
              name: 'ecom-awsSample-fabricSeries-detail',
              params: { fabricSeriesCode, pageType: 'edit' },
              query: { fabricSeriesNo },
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}

.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}

.image-col {
  padding: 0;
}

// .image-wrapper {
//   display: flex;
//   align-items: flex-start;
//   justify-content: center;
// }
// .image-wrapper img {
//   max-width: 100%;
//   max-height: 100%;
// }
.text-col {
  padding: 0;
}

.text-wrapper {
  padding: 20px;
}
</style>
